import * as $ from 'jquery';

export class Menu {

  protected menuItemSelector = '.js-menu-level-1-button';
  protected hamburgerSelector = '.js-hamburger';
  protected headerSelector = '.js-header';
  protected navigationOpenClass = 'navigation__item--open';
  protected headerResponsiveMenuOpenClass = 'header--responsiveMenuOpen';
  protected $menuButtons = $(this.menuItemSelector);
  protected $hamburger = $(this.hamburgerSelector);
  protected $header = $(this.headerSelector);
  protected enterSubSelector = '.js-enter-sub';
  protected $body = $('body');
  protected bodyNavigationOpenClass = 'navOpen';
  protected burgerMenuBreakpoint = 1200;
  protected scrollBarWidth: number = 0;
  readonly mainMenuDataAttribute = 'mainMenu';
  protected scrollBarPlaceholderElements = 'html, .header__firstRow, .header__absoluteWrapper';

  constructor() {
    this.addMenuClickWatcher();
    this.addBurgerClickWatcher();
    this.addBurgerMenuControls();
    this.addResizeWatcher();
    this.getScrollBarWidth();
    this.reloadPageOnLoginClick();
  }

  protected getScrollBarWidth() {
    const overflowValue = this.$body.css('overflow-y');
    const max = this.$body.css('overflow-y', 'scroll').outerWidth();
    const min = this.$body.css('overflow-y', 'hidden').outerWidth();
    this.$body.css('overflow-y', overflowValue);

    if (min && max && (min - max >= 0) && (min - max < 50)) {
      this.scrollBarWidth = min - max;
    }
  }

  /**
   * addMenuClickWatcher
   * watch for clicks on main menu (level 1 items)
   * and show submenu.
   */
  protected addMenuClickWatcher() {
    this.$menuButtons.on('click', (event) => {
      let $menuItem = $(event.target).parent();
      if ($menuItem.hasClass('navigation__item--sub')) {
        event.preventDefault();
        event.stopPropagation();
      }
      $('.navigation__item--level1').removeClass(this.navigationOpenClass);
      if ($menuItem.hasClass(this.navigationOpenClass)) {
        $menuItem.removeClass(this.navigationOpenClass);
      } else {
        $menuItem.addClass(this.navigationOpenClass);
        this.addMenuCloseClickWatcher($menuItem);
      }
    });
  }

  protected addMenuCloseClickWatcher($menuItem: JQuery) {
    this.$body.one('click', (event2) => {
      let targetClassList = event2.target.classList;
      if (targetClassList.contains('navigation--level2')
          || targetClassList.contains('navigation__item')
          || targetClassList.contains('navigationSubWrapper')) {
        this.addMenuCloseClickWatcher($menuItem);
      } else {
        $menuItem.removeClass(this.navigationOpenClass);
      }
    });
  }

  /**
   * addBurgerClickWatcher
   * watch for clicks on burger menu (responsive or main menu on infokosmos > 0)
   * and show small (mobile) menu
   */
  protected addBurgerClickWatcher() {
    this.$hamburger
      // initialize the mobile menu only the first time it is opened
      .one('click', this.initializeResponsiveMenu)
      // open/close the menu every time the 🍔-button gets clicked
      .on('click', (event) => {
        event.stopPropagation();
        if (this.$header.hasClass(this.headerResponsiveMenuOpenClass)) {
          this.closeBurgerMenu();
        } else {
          this.openBurgerMenu();
        }
      });
  }

  protected addResizeWatcher() {
    $(window).on('resize', () => {
      let width = $(window).outerWidth();
      if (width && width > this.burgerMenuBreakpoint) {
        this.closeBurgerMenu();
      }
    });
  }

  protected openBurgerMenu() {
    this.$header.addClass(this.headerResponsiveMenuOpenClass);
    this.$body.addClass(this.bodyNavigationOpenClass);
    $(this.scrollBarPlaceholderElements).css('padding-right', this.scrollBarWidth);
    this.addBurgerMenuCloseClickWatcher();

    // hide contents of navigationBackWrapper
    $('.navigation__backButton, .navigation__currentSite').hide();
    $('.js-responsiveNavigation .js-navigation').height('auto');
  }

  public closeBurgerMenu() {
    $('.js-header').removeClass(this.headerResponsiveMenuOpenClass);
    this.$body.removeClass(this.bodyNavigationOpenClass);
    $(this.scrollBarPlaceholderElements).css('padding-right', 0);
    $('.navigation__item--open').removeClass(this.navigationOpenClass);
    $('.navigation__item--sub').removeClass('nav-level-1--open nav-level-2--open nav-level-1--closed nav-level-2--closed');
  }

  protected addBurgerMenuCloseClickWatcher() {
    $('.js-close-burger-menu').one('click', () => {
      this.closeBurgerMenu();
    });
  }

  protected addBurgerMenuControls() {
    $(document).on('click', this.enterSubSelector, (event) => {
      const $target = $(event.currentTarget);
      const $targetNavigationItem = $target.closest('.js-menu-level');
      this.navTo($targetNavigationItem);
    });
  }

  protected navTo($targetNavigationItem) {
    const $currentNavigation = $targetNavigationItem.closest('.js-navigation');

    $targetNavigationItem.addClass(this.navigationOpenClass);

    if ($targetNavigationItem.hasClass('navigation__item--level1')) {
        $targetNavigationItem.addClass('nav-level-1--open')
            .closest('.navigation--level1')
            .find('.navigation__item--level1:not(.nav-level-1--open)')
            .addClass('nav-level-1--closed');
    } else if ($targetNavigationItem.hasClass('navigation__item--level2')) {
        $targetNavigationItem.addClass('nav-level-2--open')
            .closest('.navigation--level2')
            .find('.navigation__item--level2:not(.nav-level-2--open)')
            .addClass('nav-level-2--closed');
    }

    // remove the open and navigation__item--hidden class from all children
    $targetNavigationItem.find('.' + this.navigationOpenClass).removeClass(this.navigationOpenClass);
    $targetNavigationItem.find('.nav-level-1--open, .nav-level-2--open, .nav-level-1--closed, .nav-level-2--closed')
          .removeClass('nav-level-1--open nav-level-2--open nav-level-1--closed nav-level-2--closed');

    // set navigation__currentSite
    const $navBackWrapper = $('.header__navigationBackWrapper', $currentNavigation);
    const $navTitle = $('.navigation__title', $currentNavigation);
    this.refreshNavBackWrapper($targetNavigationItem);

    // read out new height of submenu (after adding open class)
    let targetHeight = $navBackWrapper.height();

    // add the title height (if any)
    if ($navTitle && $navTitle.height()) {
        targetHeight += $navTitle.height();
    }

    // depending on the target level, increment the target height by the (sub)elements height
    if ($targetNavigationItem.hasClass('navigation--level1')) {
      // for level1 menu, add the entire <ul>s height
      targetHeight += $targetNavigationItem.height();
    } else {
      // for level2 and level3 menus, add the height of the submenus wrapper
      targetHeight += $('.js-subMenu', $targetNavigationItem).parent().height();
    }

    $currentNavigation.height(targetHeight);
  }

  protected refreshNavBackWrapper( $currentNavigationItem?: any ) {
    const $currentNavigation = $currentNavigationItem.closest('.js-navigation');
    const $rootLevel = $currentNavigationItem.closest('.navigation--level1');
    const $lvl1 = $currentNavigationItem.closest('.js-menu-level-1');
    const $lvl2 = $currentNavigationItem.closest('.js-menu-level-2');
    const $navBackWrapper = $currentNavigation.find('>.header__navigationBackWrapper');

    if ($lvl1.length) {
      // display current sections title
      $('.navigation__currentSite', $navBackWrapper).show().text($currentNavigationItem.find('>a.navigation__itemLink').text());

      // display "back to overview" button and configure its behaviour
      $('.js-back-to-1', $navBackWrapper).show()
          .off().on('click', {target: $rootLevel}, (event) => {
            this.navTo(event.data.target);
          });

      if ($lvl2.length) {
        // display parent button and configure its behaviour
        $('.js-back-to-2', $navBackWrapper).show()
            .off().on('click', {target: $lvl1}, (event) => {
              this.navTo(event.data.target);
            })
            .find('span').text($lvl1.find('>a.js-menu-level-1-button').text());
      } else {
        $('.js-back-to-2', $navBackWrapper).off().hide();
      }
    } else {
      $('.js-back-to-1, .js-back-to-2', $navBackWrapper).off().hide();
      $('.navigation__currentSite', $navBackWrapper).hide().text('');
    }
  }

  protected reloadPageOnLoginClick() {
    $(document).on('click', '.js-metaLoginLink.login', () => {
      setTimeout(
        function() {
          window.location.reload();
        },
        3000
      );
    });
  }

  protected initializeResponsiveMenu() {
    $('.js-facultiesSelect').clone().prependTo($('.js-responsiveNavigation-main').parent());
    $('.js-servicesSelect').clone().prependTo('.js-responsiveNavigationMeta');
    $('.js-navigation-main').clone().appendTo('.js-responsiveNavigation-main');
    $('.js-navigation-sub').clone().appendTo('.js-responsiveNavigation-sub');
    $('.js-metaSignLanguageLink').parent().clone().appendTo('.js-responsiveNavigationMeta');
    $('.js-metaEasyLanguageLink').parent().clone().appendTo('.js-responsiveNavigationMeta');
    $('.js-metaLoginLink').parent().clone().appendTo('.js-responsiveNavigationMeta');
    $('.js-metaLanguageSwitch').clone().appendTo('.js-responsiveNavigationMeta');
  }
}
